class ObjectUtilsClass {
  difference(obj1: Object, obj2: Object) {
    const result: Object = {};

    const keys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);

    for (const key of Array.from(keys)) {
      const val1 = obj1[key];
      const val2 = obj2[key];

      const bothAreObjects =
        typeof val1 === "object" &&
        typeof val2 === "object" &&
        val1 !== null &&
        val2 !== null;

      if (bothAreObjects) {
        const nestedDiff = ObjectUtils.difference(val1, val2);
        if (Object.keys(nestedDiff).length > 0) {
          result[key] = nestedDiff;
        }
      } else if (val1 !== val2) {
        result[key] = {
          initial: val1,
          now: val2,
        };
      }
    }

    return result;
  }
}
const ObjectUtils = new ObjectUtilsClass();
export default ObjectUtils;
